import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { jobOffer } from 'job/model/job-offer.fragments';
import { JobOfferOutput } from 'job/model/job-offer.output';

import { ApiQuery } from '../../../../common/model/api.query';

export interface FetchJobOffersByIdsParams {
	readonly ids: string[];
}

@Injectable({ providedIn: 'root' })
export class FetchJobOffersByIdsApiQuery extends ApiQuery<
	JobOfferOutput[],
	FetchJobOffersByIdsParams
> {
	client = 'iam';
	document = gql`
		query FetchJobOffersByIds($ids: [UUID]!) {
			fetchJobOffersByIds(ids: $ids) {
				...JobOffer
			}
		}
		${jobOffer}
	`;
	method = 'fetchJobOffersByIds';
}
